module.exports = "/assets/data/47d052936d04063c34a0d6f85e8a3e2d-TS25.data.json";